module.exports = __webpack_public_path__ + "img/icon_history_que_1@4x.04ee108f.png";